module.exports = __webpack_public_path__ + "static/demo-screen-1-3f0b50b351c772f30be3367255d50499.jpg";